import IWidget from '@orcha/types/widget';
import Image from 'next/image';
import { Box } from '@mui/material';
import { widgetSelector } from '../widgets';

interface WidgetListProps {
  widgets?: IWidget[];
}

const WidgetList = (props: WidgetListProps) => {
  const { widgets } = props;
  const sortedWidgets = widgets?.sort(function (a, b) {
    return a.order - b.order;
  });

  return (
    <>
      {sortedWidgets?.map((widget) => {
        const { name, configuration, order } = widget;
        const WidgetComponent = widgetSelector[name];

        return WidgetComponent ? (
          <Box key={`${name}-${order}`} data-testid="widget-component">
            <WidgetComponent
              FlexibleImageComponent={Image}
              widgets={widget.widgets}
              {...configuration}
            />
          </Box>
        ) : undefined;
      })}
    </>
  );
};

export default WidgetList;
